import { TrackingEventIds } from "./../../../../tracking/constants/TrackingEventIds";
import { TrackingCache } from "./../../../../tracking/TrackingCache";
import { DesktopDeviceInformationTrackingEvent } from "./../../../../tracking/DesktopDeviceInformationTrackingEvent";
import { BasicTrackingCommand } from "./basis/BasicTrackingCommand";
import { BasicModel } from "../../../model/BasicModel";

export class BasicDesktopDeviceInformationTrackingCommand extends BasicTrackingCommand {
    public execute(commandVars: any = null): void {
        let trackingEvent: DesktopDeviceInformationTrackingEvent = (<DesktopDeviceInformationTrackingEvent>TrackingCache.getInstance().getEvent(TrackingEventIds.DESKTOP_DEVICE_INFORMATION));

        trackingEvent.playerId = BasicModel.userData.playerID;

        TrackingCache.getInstance().sendEvent(TrackingEventIds.DESKTOP_DEVICE_INFORMATION);
    }
}
